import React, { useEffect, useMemo, useState } from "react";
import { cdnImg } from "../../Utils/cdnImage";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { useNavigate } from "react-router-dom";
const GameMenu = () => {
  const tab = useContextSelector(AuthContext, (ctx) => {
    return ctx.tab;
  });
  const sportTab = useContextSelector(AuthContext, (ctx) => {
    return ctx.sportTab;
  });
  const setSearch = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSearch;
  });
  const setSportsTab = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSportsTab;
  });
  const stableTab = useMemo(() => tab, [tab]);
  const [count, setCount] = useState({
    cricketInplayCount: 0,
    soccerInplayCount: 0,
    tennisInplayCount: 0,
  });

  const inPlayCount = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.inPlayCountMobile,
    );
      if (response_users.success) {
        if (response_users?.results) {
          setCount(response_users?.results);
        }
      
    }
  };
  useEffect(() => {
    inPlayCount();
  }, []);

  const menuItems = [
    // {
    //   key: "casino",
    //   label: "Casino",
    //   icon: "icon-casino",
    //   liveCount: null,
    //   isNew: true,
    // },
    {
      key: "cricket",
      label: "Cricket",
      icon: "icon-cricket",
      liveCount: count?.cricketInplayCount,
    },
    {
      key: "soccer",
      label: "Soccer",
      icon: "icon-soccer",
      liveCount: count?.soccerInplayCount,
    },
    {
      key: "tennis",
      label: "Tennis",
      icon: "icon-tennis",
      liveCount: count?.tennisInplayCount,
    },
    // {
    //   key: "horseracing",
    //   label: "Horse Racing",
    //   icon: "icon-HR",
    //   liveCount: null,
    // },
  ];
  const handleTabClick = (tab) => {
    setSportsTab(tab);
  };
  const navigate = useNavigate();
  return (
    <div id="highlightLabel" className="highlight-fix">
      <div onClick={() => setSearch(true)} className="a-search">
        Search
      </div>
      <div
        id="frame"
        className="wrap-highlight ps ps--theme_default ps--active-x"
        data-ps-id="df872e31-8042-fee0-40e5-a97c3c1d2984"
      >
        <ul id="label" style={{ left: "0px" }}>
          {menuItems.map((item) => (
            <li
              key={item.key}
              className={`${sportTab === item.key ? "select" : ""} ${
                item.key === "casino" ? "menu-casino" : ""
              }`}
              onClick={() => {
                if (item?.key == "casino") {
                  window.location.replace("/casino?type=casino&provider=PT");
                } else if (item?.key == "horseracing") {
                  navigate("/horse-racing-sky");
                } else {
                  handleTabClick(item.key);
                }
              }}
            >
              {/* Show NEW tag only for casino */}
              {item.isNew && <span className="tag-new">New</span>}

              {/* Show Live Count if available */}
              {item.liveCount !== null && (
                <span className="tag-live">
                  <strong /> {item.liveCount}
                </span>
              )}

              <a href="#" neua={item.label} onClick={(e) => e.preventDefault()}>
                <img
                  className={item.icon}
                  src={cdnImg("assets/images/transparent.gif")}
                  alt={item.label}
                />
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default GameMenu;
